<template>
  <div>
    <v-form ref="form">
      <v-row justify="space-between">
        <v-col>
          <h4 class="greyDark--text font-weight-bold">
            {{ $t('book/facility:common.facility-state') }}
          </h4>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                  color="primary"
                  rounded
                  elevation="0"
                  class="mr-3 mb-3 mb-md-0 white--text"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!code.code"
                  @click="$router.push(`/${$store.state.manager.bookModuleUrl}/public/qrcode/${code.code}/onboarding`)"
              >
                {{ $t('book/technical-info:btn-onboarding') }}
              </v-btn>
            </template>
            <span>{{ $t('book/technical-info:onboarding-tooltip')}}</span>
          </v-tooltip>
          <p class="greyMedium--text mb-0 mt-3" v-if="!code.code">{{ $t('book/technical-info:no-qr-code') }}</p>
        </v-col>
        <v-col class="text-right">
          <p v-if="state.savedOn" class="greyTint--text">{{ $t('common:last-updated-on') }} {{ state.savedOn }}</p>
          <p v-if="state.savedByUsername" class="greyTint--text">{{ $t('book/technical-info:last-updated-by') }} {{ state.savedByUsername }}</p>
          <p v-if="!state.savedOn && !state.savedByUsername" class="scaleOrange--text">{{ $t('book/facility:facility.dashboard.information.state.not-done') }}</p>
        </v-col>
      </v-row>
      <!-- GBU / Gefahrenüberprüfungen  ... todo: no english translations done yet -->
      <v-row justify="space-between">
        <v-col>
          <h5 class="greyDark--text font-weight-bold">
             GBU / Gefahrenüberprüfungen
          </h5>
        </v-col>
      </v-row>
      <div  v-if="!gbuResultsLoaded">
        <p class="grey--text">lade Daten...</p>
      </div>
      <div v-else-if="gbuResults.length === 0">
        <p class="grey--text">Keine Gefahrenüberprüfungen vorhanden.</p>
      </div>
      <div v-else >
        <div class="mb-4">
          <BaseButton
              v-if="gbuReports[0]"
              color="primary"
              btnText="Zeige aktuellen GBU-Befund"
              @clickedButton="showFinishedReport(gbuReports[0])"
          />
        </div>
        <v-expansion-panels tile flat>
          <div v-for="(gbu, index) in gbuResults" :key="index" style="width: 100%;">
            <v-expansion-panel  class="my-1">
              <v-expansion-panel-header class="pa-3">
                <v-row>
                  <v-col>
                <h6 class="mb-0 ml-2 greyDark--text">GBU vom {{ gbu.inspectionDate.toString()}} </h6>
                  </v-col>
                  <v-col> <h6 class="mb-0 ml-2 greyDark--text">Prüfer: {{gbu.inspectorName}}</h6></v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager class="mt-2">
                <BaseButton
                    color="primary"
                    btnText="Unterstützungs-Bericht erstellen"
                    @clickedButton="openSupportReportDialog(gbu)"
                />
                <BaseButton
                    color="primary"
                    :btnText="gbuSelectedProtections[index] === null ? 'Erzeuge Befund' : 'Ändere Befund'"
                    @clickedButton="openReportDialog(gbu, gbuSelectedProtections[index])"
                />
                <BaseButton
                    v-if="gbuReports[index]"
                    color="primary"
                    btnText="Zeige Befund"
                    @clickedButton="showFinishedReport(gbuReports[index])"
                />
                <!-- only show raw inspection-report, if there is no generated gbuReport with protections -->
                <div v-if="!gbuReports[index]">
                <!-- Gefahrenüberprüfung -->
                  <h4 class="primary--text mt-4" >Prüfer</h4>
                  <v-row>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Name/Kürzel:</span> {{gbu.inspectorName}}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Tel.:</span> {{gbu.inspectorTel}}</p>
                    </v-col>
                  </v-row>
                  <p class="mb-2 ml-2 greyDark--text"><span class="bold">Prüf-Datum:</span> {{gbu.inspectionDate}}</p>
                  <p class="mb-0 ml-2 greyDark--text pre-wrap"><span class="bold">Teilnehmer:</span> {{gbu.attendees}}</p>

                  <h4 class="primary--text mt-4" >Nutzung / Betrieb</h4>
                  <v-row>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Nutzungsart:</span> {{gbu.typeOfUse}}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Nutzungshäufigkeit:</span> {{gbu.userFrequency}}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Nutzerkreis:</span> {{gbu.rangeOfUsers}}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-0 ml-2 greyDark--text"><span class="bold">Betrieb:</span> {{gbu.operation ? gbu.operation.toString() : ''}}</p>
                    </v-col>
                  </v-row>

                  <div v-if="gbu.inspectionDeadlines">
                    <h4 class="primary--text mt-4" >Prüffristen</h4>
                    <p class="mb-2 ml-2 greyDark--text"><span class="bold">Prüffrist für wiederkehrende Prüfungen:</span>
                      {{gbu.inspectionDeadlines.recurring}}</p>
                    <p class="mb-2 ml-2 greyDark--text"><span class="bold">Letzte wiederkehrende Prüfung:</span>
                      {{gbu.inspectionDeadlines.lastRecurring}}</p>
                    <p class="mb-2 ml-2 greyDark--text"><span class="bold">Letzte Einweisung beauftragte Person (Aufzugswärter) :</span>
                      {{gbu.inspectionDeadlines.lastPerson}}</p>
                    <p class="mb-2 ml-2 greyDark--text"><span class="bold">Letzte Prüfung AwSV:</span>
                      {{gbu.inspectionDeadlines.awsv}}</p>
                  </div>

                  <!-- GBU-Prüfpunkte -->
                  <h4 class="primary--text mt-6" >GBU-Prüfpunkte</h4>

                  <!-- GBU-Prüfpunkte risk overview line -->
                  <v-row v-if="gbu.sumGbuRisks !== undefined" class="px-3" align="stretch">
                    <v-col class="px-0">
                      <div :style="{'background-color': getRiskCol(3)}" class="px-1 risk-col">
                      {{gbu.sumGbuRisks.countHighRisk}} x Hohes Risiko </div>

                    </v-col>
                    <v-col class="px-0">
                      <div :style="{'background-color': getRiskCol(2)}" class="px-1 risk-col">
                      {{gbu.sumGbuRisks.countMediumRisk}} x Mittleres Risiko
                      </div>
                    </v-col>
                    <v-col class="px-0">
                      <div :style="{'background-color': getRiskCol(1)}" class="px-1 risk-col">
                      {{gbu.sumGbuRisks.countLowRisk}} x Geringes Risiko
                      </div>
                    </v-col>
                    <v-col class="px-0">
                      <div :style="{'background-color': getRiskCol(0)}" class="px-1 risk-col">
                      {{gbu.sumGbuRisks.countNoRisk}} x Kein Risiko
                      </div>
                    </v-col>
                    <v-col class="px-0">
                      <div :style="{'background-color': getRiskCol(4)}" class="px-1 risk-col">
                      {{gbu.sumGbuRisks.countNotApplicable}} x Nicht Zutreffend
                      </div>
                    </v-col>

                  </v-row>

                  <v-expansion-panels multiple  >
                    <div v-for="chapter in gbu.chapters" :key="chapter.nr" class="full-width mb-2 py-0">
                      <v-expansion-panel class="px-0 mx-0 mt-1">
                        <v-expansion-panel-header class="py-0"  :color="getChapterRiskColor(chapter)" >
                          <v-container class="pa-0 ma-0">
                            <v-row>
                              <v-col class="pa-0">
                                <h5 class="ma-1 risk-col">{{chapter.nr}} {{chapter.title}}</h5>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="pa-0">
                                <p class="mx-1 mt-1 mb-2 greyDark--text risk-col">{{getRiskText(chapter)}}</p>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-0 ma-0 mt-1">
                          <div v-for="check in chapter.checks" :key="check.nr" class="mx-0 mt-1 pt-2"
                               :style="{'background-color': getRiskColor(check)}">
                            <h6 class="pt-1 mt-0 mb-0 ml-2 greyDark--text">{{check.nr}} {{check.check}} </h6>
                            <p v-if="check.sect && check.sect.trim().length > 0"
                               class="mb-0 ml-2 greyDark--text small-text">Abschnitt EN81-80: {{check.sect}}</p>
                            <div v-if="check.risk !=='info'">
                              <v-row>
                                <v-col>
                                  <p class="mb-0 ml-2 greyDark--text">{{requirementsFullfilledText(check)}}</p>
                                </v-col>
                                <v-col v-if="check.isRisk === 'ja'">
                                  <p class="mb-0 ml-2 greyDark--text">Risikostufe: {{check.risk}}</p>
                                </v-col>
                              </v-row>
                              <div v-if="check.note" class="ml-2 mb-1 greyDark--text pre-wrap">Bemerkung von SV: {{check.note}}</div>
                            </div>
                            <div v-else class="ml-2 mb-1 greyDark--text pre-wrap">{{check.note}}</div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </div>
                  </v-expansion-panels>
                  <div v-if="gbu.note !== ''">
                    <p class="mb-0 ml-2 greyDark--text">Bemerkungen zur GBU: {{gbu.note}}</p>
                  </div>


                  <!-- Zustandsbewertung-->
                  <div v-if="gbu.useConditionAssessment" class="mt-8">
                    <h4 class="primary--text">{{ gbu.conditionAssessment.displayName }}</h4> <!-- Zustandsbewertung Title -->
                    <div>
                      <v-expansion-panels multiple>
                          <div v-for="subHeader in gbu.conditionAssessment.content" :key="subHeader.name"
                               class="full-width mb-2 py-0">
                          <v-expansion-panel class="px-0 mx-0 mt-1">
                            <v-expansion-panel-header class="py-0" :color="getConditionSubheaderColor(subHeader)">
                                <h6 class="mb-0 ml-2 risk-col">{{subHeader.displayName}} </h6>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="pa-0 ma-0 mt-1">
                              <div v-for="item in subHeader.content" :key="item.name" class="mt-1">

                                <div v-if="item.type === 'enum'" :style="{'background-color': getConditionItemColor(item)}">

                                    <v-row>
                                      <v-col cols="6" class="ma-0">
                                        <p class="mb-0 ml-2 greyDark--text">{{item.displayName}}:</p>
                                      </v-col>
                                      <v-col cols="1" class="ma-0">
                                        <p class="mb-0 greyDark--text center-text">{{item.value}}</p>
                                      </v-col>
                                      <v-col cols="4" class="ma-0">
                                        <p class="mb-0 greyDark--text">{{item.displayValue}}</p>
                                      </v-col>
                                    </v-row>

                                </div>
                                <div v-else>
                                  <p>{{item.name}}: type: {{item.type}} not implemented yet</p>
                                </div>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </div>
                      </v-expansion-panels>
                      <div v-if="gbu.conditionAssessmentNote !== ''">
                        <p class="mb-0 ml-2 greyDark--text">Bemerkung zur Zustandsbewertung: {{gbu.conditionAssessmentNote}}</p>
                      </div>
                    </div>
                  </div>
                  <p v-else  class="mt-4 grey--text">Keine Zustandsbewertung aufgenommen.</p>


                  <!-- Umfeldbetrachtung -->
                  <div v-if="gbu.useSurroundingsConsideration" class="mt-8">
                    <h4 class="primary--text" >Umfeldbetrachtung</h4>
                    <!-- GBU-Prüfpunkte risk overview line -->
                    <v-row v-if="gbu.sumSurroundingsRisks !== undefined" class="px-3" align="stretch">
                      <v-col class="px-0">
                        <div :style="{'background-color': getRiskCol(3)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countHighRisk}} x Hohes Risiko </div>

                      </v-col>
                      <v-col class="px-0">
                        <div :style="{'background-color': getRiskCol(2)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countMediumRisk}} x Mittleres Risiko
                        </div>
                      </v-col>
                      <v-col class="px-0">
                        <div :style="{'background-color': getRiskCol(1)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countLowRisk}} x Geringes Risiko
                        </div>
                      </v-col>
                      <v-col class="px-0">
                        <div :style="{'background-color': getRiskCol(0)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countNoRisk}} x Kein Risiko
                        </div>
                      </v-col>
                      <v-col class="px-0">
                        <div :style="{'background-color': getRiskCol(4)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countNotApplicable}} x Nicht Zutreffend
                        </div>
                      </v-col>
                      <v-col v-if="gbu.sumSurroundingsRisks.countNotSet > 0" class="px-0">
                        <div :style="{'background-color': getRiskCol(1)}" class="px-1 risk-col">
                          {{gbu.sumSurroundingsRisks.countNotSet}} x Unbekannte Risikostufe
                        </div>
                      </v-col>
                    </v-row>

                    <v-expansion-panels multiple  >
                      <div v-for="(chapter, index2) in gbu.surroundingsChapters" :key="index.toString()+'_'+index2" class="full-width mb-2 py-0">
                        <v-expansion-panel class="px-0 mx-0 mt-1">
                          <v-expansion-panel-header class="py-0"  :color="getChapterRiskColor(chapter)" >
                            <v-container class="pa-0 ma-0">
                              <v-row>
                                <v-col class="pa-0">
                                  <h5 class="ma-1 risk-col">{{chapter.nr}} {{chapter.title}}</h5>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col class="pa-0">
                                  <p class="mx-1 mt-1 mb-2 greyDark--text risk-col">{{getRiskText(chapter)}}</p>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="pa-0 ma-0 mt-1">
                            <div v-for="check in chapter.checks" :key="check.nr" class="mx-0 mt-1 pt-2"
                                 :style="{'background-color': getRiskColor(check)}">
                              <h6 class="pt-1 mt-0 mb-0 ml-2 greyDark--text">{{check.nr}} {{check.check}} </h6>
                              <p v-if="check.sect && check.sect.trim().length > 0"
                                 class="mb-0 ml-2 greyDark--text small-text">Abschnitt: {{check.sect}}</p>
                              <v-row>
                                <v-col>
                                  <p class="mb-0 ml-2 greyDark--text">{{requirementsFullfilledText(check)}}</p>
                                </v-col>
                                <v-col v-if="check.isRisk === 'ja'">
                                  <p class="mb-0 ml-2 greyDark--text">Risikostufe: {{check.risk}}</p>
                                </v-col>
                              </v-row>
                              <div v-if="check.note" class="ml-2 mb-1 greyDark--text pre-wrap">Bemerkung von SV: {{check.note}}</div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </div>
                    </v-expansion-panels>
                    <div v-if="gbu.surroundingsNote !== ''">
                      <p class="mb-0 ml-2 greyDark--text">Bemerkungen zur Umfeldbetrachtung: {{gbu.surroundingsNote}}</p>
                    </div>

                  </div>
                  <p v-else  class="mt-4 grey--text">Keine Umfeldbetrachtung aufgenommen.</p>
                </div>
              </v-expansion-panel-content>

            </v-expansion-panel>
          </div>
        </v-expansion-panels>
      </div>
      <v-row justify="space-between">
        <v-col>
          <h5 class="greyDark--text font-weight-bold mt-4">
            {{$t('book/facility:common.facility-state-general')}}
          </h5>
        </v-col>
      </v-row>
      <v-expansion-panels tile flat v-model="statePanels">
        <!-- Documentations -->
        <v-expansion-panel class="my-1" ref="panel_0">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.docu') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <RuleStateTable
                ref="ruleStateTable"
                :header="docuHeaders"
                read-only
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Car -->
        <v-expansion-panel class="my-1" ref="panel_1">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.car') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <StateTable :data="state" :header="docuHeaders" :fields="carHeaders" readOnly/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- On every stop -->
        <v-expansion-panel class="my-1" ref="panel_2">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.stop') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <StateTable :data="state" :header="docuHeaders" :fields="stopHeaders" readOnly/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Engine room -->
        <v-expansion-panel class="my-1" ref="panel_3">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.engine-room') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <StateTable :data="state" :header="docuHeaders" :fields="erHeaders" readOnly/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Shaft / car roof -->
        <v-expansion-panel class="my-1" ref="panel_4">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.shaft') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <StateTable :data="state" :header="docuHeaders" :fields="shaftHeaders" readOnly/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Shaft pit -->
        <v-expansion-panel class="my-1" ref="panel_5">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.shaft-pit') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <StateTable :data="state" :header="docuHeaders" :fields="shaftPitHeaders" readOnly/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Image Panel -->
        <v-expansion-panel class="my-1" ref="panel_6">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.images') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <RuleStateTable
                ref="pictureTable"
                :header="[$t('common:name'), $t('common:image_plural')]"
                read-only
                is-picture-state
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Summary -->
        <v-expansion-panel class="my-1" ref="panel_7">
          <v-expansion-panel-header class="pa-3">
            <h6 class="mb-0 ml-2 greyDark--text">{{ $t('book/facility:facility.dashboard.information.state.panel-titles.summary') }}</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class="mt-2">
            <v-textarea
                outlined
                disabled
                v-model="state.summary"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
    <FacilityGbuReportDialogForm
      ref="gbuReportForm"
      @update-gbu="updateGbu($event)"
    />
  </div>
</template>
<script>
import ElevatorState from "@/modules/book/data/elevator-state";
import ElevatorStateService from "@/modules/book/services/elevator-state-service";
import DataUtils from "@/modules/core/services/data-utils";
import StateTable from "@/modules/core/components/DataTable/StateTable";
import StateTableUtils from "@/modules/core/services/state-table-utils";
import Utils from "@/modules/core/services/utils";
import FacilityService from "@/modules/book/services/facility-service";
import QRCodeService from "@/modules/book/services/qrcode-service";
import QRCode from "@/modules/book/data/qrcode";
import DocumentationService from "@/modules/core/services/documentation-service";
import FacilityDocumentation from "@/modules/book/data/facility-documentation";
import EnumService from "@/modules/core/services/enum-service";
import InfoService from "@/modules/core/services/info-service";
import RuleStateTable from "@/modules/core/components/DataTable/RuleStateTable";
import Vue from "vue";
import DateUtils from "@/modules/core/services/date-utils";
import GbuResultService from "@/modules/book/services/gbu-result-service";
import BaseButton from "@/modules/core/components/Base/BaseButton.vue";
import FacilityGbuReportDialogForm from "@/modules/book/views/facility/facility/formDialogs/FacilityGbuReportDialogForm.vue"

export default {
  name: "FacilityStateInfoTab",
  components: {
    FacilityGbuReportDialogForm,
    StateTable,
    RuleStateTable,
    BaseButton,
  },
  data() {
    return {
      state: new ElevatorState(),
      code: new QRCode(),
      facilityPictures: [],
      carHeaders: [],
      stopHeaders: [],
      erHeaders: [],
      shaftHeaders: [],
      shaftPitHeaders: [],
      facilityDocumentations: [],

      statePanels: null,
      gbuResults: [],
      gbuSelectedProtections: [],
      gbuReports: [],
      gbuResultsLoaded: false,
    }
  },
  computed: {
    headers() {
      return [
        this.$t('book/facility:facility.dashboard.information.state.check'),
        this.$t('common:status'),
        this.$t('common:comment')
      ]
    },

    docuHeaders() {
      return [
        this.$t('book/facility:facility.dashboard.information.state.check'),
        this.$t('common:status'),
        this.$t('common:comment'),
        this.$t('common:document_plural')
      ]
    },

    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  methods: {
    openReportDialog(gbu, selectedProtections) {
      let withCostEstimate;
      if (selectedProtections) {
        withCostEstimate = selectedProtections.hasCostEstimate;
      }
      else {
        withCostEstimate = false;
      }
      let gbuClient = selectedProtections ? selectedProtections.gbuClient : this.getLatestGbuClient();
      //console.log( JSON.stringify(gbu, null, 2 )); //  debug info
      this.$refs.gbuReportForm.openDialog(gbu, withCostEstimate, selectedProtections, gbuClient);
    },
    openSupportReportDialog(gbu) {
      let gbuClient = gbu.gbuClient ? gbu.gbuClient : this.getLatestGbuClient();
      //console.log( JSON.stringify(gbu, null, 2 )); // debug info
      this.$refs.gbuReportForm.openSupportReportDialog(gbu, gbuClient);
    },

    getLatestGbuClient() {
      for (let i=0 ; i< this.gbuResults.length; i++) {
        if (this.gbuResults[i].gbuClient) {
          return this.gbuResults[i].gbuClient;
        }
      }
      return null;
    },

    /**
     * update gbu-display and show_report-buttons after a gbuReport is deleted in FacilityDocInfoTab
     * @param gbuReportId id of the deleted gbuReport
     */
    deleteGbuReportId(gbuReportId) {
      for(let i=0; i < this.gbuReports.length; i++) {
        if (this.gbuReports[i] === gbuReportId) {
          this.$set(this.gbuReports, i, null);
        }
      }
    },

    updateGbu(gbuId) {
      let index= -1;
      for (let i=0; i< this.gbuResults.length; i++) {
        if (this.gbuResults[i].id === gbuId) {
          index = i;
          break;
        }
      }
      if (index === -1) {
        return;  // gbuId not found
      }
      // update GbuReportId and gbuSelectedProtections
      GbuResultService.readFromAPI(gbuId,
          (resp) => {
            let changedGbu = resp.data;
            const gbuReport = changedGbu.gbuReport;
            let newReportId = (gbuReport && gbuReport.deleted === false) ? gbuReport.id : null;
            this.$set(this.gbuReports, index, newReportId);
            let newProtectionsValue = changedGbu.jsonSelectedProtections ?
                JSON.parse(changedGbu.jsonSelectedProtections) : null;
            this.$set(this.gbuSelectedProtections, index, newProtectionsValue);
          },
          (error) => {
            console.log("Failed get GbuResult " + error);
          }
      );
    },
    translateAndGetElevatorStateFields() {
      this.carHeaders = StateTableUtils.getElevatorStateCarFieldsAndTranslation();
      this.stopHeaders = StateTableUtils.getElevatorStateStopFieldsAndTranslation();
      this.erHeaders = StateTableUtils.getElevatorStateERFieldsAndTranslation();
      this.shaftHeaders = StateTableUtils.getElevatorStateShaftFieldsAndTranslation();
      this.shaftPitHeaders = StateTableUtils.getElevatorStateShaftPitFieldsAndTranslation();
      EnumService.translateAndSortEnumObject(this.facilityPictures, 'enums:facility-documentation-types.');
      EnumService.translateAndSortEnumObject(this.state.ruleStates, "enums:facility-documentation-types.")
    },

    async getRuleDocumentations() {
      let promises = [];

      for (let rule of this.state.ruleStates) {
        if (rule.documents.length > 0) {
          for (let document of rule.documents) {
            promises.push(
                new Promise(resolve => {
                  DocumentationService.getDocByTypeAndId(
                      document.id,
                      document.fileType,
                      document.documentType,
                      document.facilityId,
                      (res) => {
                        Vue.set(document, "src", res);
                        resolve(document)
                      },
                      (error) => {
                        this.$logger.error("Failed loading documentation source for document " + document.id +", because: " + error);
                      }
                  )
                })
            )
          }
        }
      }

      await Promise.all(promises)
    },

    requirementsFullfilledText(check) {
      let text = 'Anforderung erfüllt: ';
      if (check.isRisk === 'ja') {
        return text + 'nein';
      }
      else if (check.isRisk === 'nein') {
        return text + 'ja';
      }
      else if (check.isRisk === 'nicht zutreffend'){
        return text + check.isRisk;
      }
    },
    getRiskColor(gbuCheck) {
      return this.getRiskCol(this.getRiskColorNr(gbuCheck));
    },

    getRiskColorNr(gbuCheck) {
      if (gbuCheck.isRisk === 'ja' &&  !gbuCheck.risk) {
        return 1;   // risk not set
      }
      if (gbuCheck.isRisk === 'nein' ) {
        return 0;
      }
      if (gbuCheck.isRisk === 'nicht zutreffend' ) {
        return 4;
      }
      if (gbuCheck.isRisk === 'ja' &&  gbuCheck.risk.toLowerCase().startsWith('hoch')) {
        return 3;
      }
      if (gbuCheck.isRisk === 'ja' &&  gbuCheck.risk.toLowerCase().startsWith('mittel')) {
        return 2;
      }
      if (gbuCheck.isRisk === 'ja' &&  gbuCheck.risk.toLowerCase().startsWith('niedrig')) {
        return 1;
      }
      if (gbuCheck.isRisk === 'info') {
        return 5;
      }
      return 4; // default gray
    },

    getChapterRiskColor(chapter) {
      let highestRiskColNr = -1;
      for (let check of chapter.checks) {
        let checkNr =  this.getRiskColorNr(check);
        if (checkNr < 4 && checkNr > highestRiskColNr)  {
          highestRiskColNr = checkNr;
        }
      }
      if (highestRiskColNr === -1) {
        highestRiskColNr = 4; // default gray/ not applicable
      }
      return this.getRiskCol(highestRiskColNr);
    },

    getRiskCol(nr, transparenceHexString) {
      // no risk =0  low= 1, medium = 2, high =3, not applicable = 4, info = 5
      const riskColors=  [ '#00ff0080', '#ffff0080', '#ff800080', '#ff000080', '#a0a0a080', '#ffffff80'];
      const riskColorsFull=  [ '#00ff00', '#ffff00', '#ff8000', '#ff0000', '#a0a0a0', '#ffffff'];
      if (transparenceHexString === undefined) {
        return riskColors[nr];
      }
      else return riskColorsFull[nr] + transparenceHexString;
    },

    getConditionSubheaderColor(subHeader) {
        const length = subHeader.content[0].items.length;
       return this.getConditionColor(subHeader.conditionNr, length);
    },
    getConditionItemColor(item){
      return this.getConditionColor(item.value, item.items.length);
    },

    getConditionColor(value, length) {
      if (value === undefined || value === null) {
        return '#ffffff00'; // transparent
      }
      const fiveVals = [ '#00ff0080', '#ffff0080', '#ff800080', '#ff000080', '#a0a0a080']; // last one is 'not applicable'
      const sixVals = [ '#00ff0080','#80ff0080','#FFFF0080', '#ffA00080', '#ff600080', '#ff000080'];
      if (length >= 6) {
        return sixVals[value-1];
      }
      return fiveVals[value-1];
    },

    addRiskCounts(chapters) {
      let sumRisks = {
        countHighRisk: 0,
        countMediumRisk: 0,
        countLowRisk: 0,
        countNoRisk: 0,
        countNotApplicable: 0,
        countNotSet:0
      }
      for (let chapter of chapters) {
        chapter.countHighRisk = 0;
        chapter.countMediumRisk = 0;
        chapter.countLowRisk = 0 ;
        chapter.countNoRisk = 0;
        chapter.countNotApplicable = 0;
        chapter.countNotSet = 0;
        for (let check of chapter.checks) {
          if (check.risk && check.risk.toLowerCase() === 'info') {
            continue;
          }
          else if (!check.risk && check.isRisk === 'ja') {
            chapter.countNotSet++;
            sumRisks.countNotSet++;
          }

          else if (check.isRisk.toLowerCase() === 'nicht zutreffend') {
            chapter.countNotApplicable++;
            sumRisks.countNotApplicable++;
          }
          else if (check.isRisk.toLowerCase() === 'nein') {
            chapter.countNoRisk++;
            sumRisks.countNoRisk++;
          }


          else if  (check.isRisk === 'ja' && check.risk) {
            if (check.risk.toLowerCase().startsWith('hoch') ) {
              chapter.countHighRisk++;
              sumRisks.countHighRisk++;
            }
            else if (check.risk.toLowerCase().startsWith('mittel') ) {
              chapter.countMediumRisk++;
              sumRisks.countMediumRisk ++;
            }
            else if (check.risk.toLowerCase().startsWith('niedrig') ) {
              chapter.countLowRisk++;
              sumRisks.countLowRisk++;
            }
            else {
              console.log("error - unknown risk " + check.risk)
            }
          }
          else {
            console.log("error - unknown isRisk " + check.isRisk)
          }
        }
      }
      return sumRisks;
    },

    getRiskText(chapter) {
      let riskText = '';
      if (chapter.countHighRisk > 0) {
        riskText = chapter.countHighRisk.toString() + ' x Hohes Risiko';
      }
      if (chapter.countMediumRisk > 0) {
        riskText = riskText.length !== 0  ? riskText + ', ' : '';
        riskText = riskText + chapter.countMediumRisk.toString() + ' x Mittleres Risiko';
      }
      if (chapter.countLowRisk > 0) {
        riskText = riskText.length !== 0  ? riskText + ', ' : '';
        riskText = riskText + chapter.countLowRisk.toString() + ' x Geringes Risiko';
      }
      if (chapter.countNoRisk > 0) {
        riskText = riskText.length !== 0  ? riskText + ', ' : '';
        riskText = riskText + chapter.countNoRisk.toString() + ' x Kein Risiko';
      }
      if (chapter.countNotApplicable > 0) {
        riskText = riskText.length !== 0  ? riskText + ', ' : '';
        riskText = riskText + chapter.countNotApplicable.toString() + ' x Nicht Zutreffend';
      }
      if (chapter.countNotSet > 0) {
        riskText = riskText.length !== 0  ? riskText + ', ' : '';
        riskText = riskText + chapter.countNotSet.toString() + ' x Unbekannte Risikostufe';
      }
      return riskText;
    },

    showFinishedReport(docId) {
      const facilityId = this.$route.params.id;
      DocumentationService.getDocByTypeAndId(
          docId,
          'application/pdf',
          'FACILITY',
          facilityId,
          (result) => {
            this.openPDFInNewTab(result);
          }
      );
    },
    openPDFInNewTab(docSource) {
      const base64Result = docSource.split('base64,')[1];

      // convert the base64 to a blob
      const blob = Utils.base64toBlob(base64Result, 'application/pdf');
      // create url for the blob
      const blobUrl = URL.createObjectURL(blob);
      // open the blob in a new tab
      window.open(blobUrl, '_blank');
    },

  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.translateAndGetElevatorStateFields();
      });
    },

    statePanels() {
      setTimeout(() => {
        this.$vuetify.goTo(this.$refs['panel_' + this.statePanels], {duration: 1000, offset: 100, easing: 'easeInOutCubic'})
      }, 250);
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.push('/404');
    }

    FacilityService.readFromAPI(this.$route.params.id,
        (res) => {

          if (res.data.qrcode) {
            QRCodeService.readFromAPI(res.data.qrcode,
                (resp) => {
                  this.code = DataUtils.parseDataToSingleObject(resp.data, QRCode);
                }
            )
          }
        }
    )

    GbuResultService.readAllForFacilityFromAPI(this.$route.params.id,
        (resp) => {
          let gbuResultArray = resp.data;
          if (gbuResultArray == null) {
            this.$router.push('/404');
            return;
          }
          if (gbuResultArray.length !== undefined && gbuResultArray.length >= 1) {
            for (let i=0; i< gbuResultArray.length; i++) {
              const gbu= JSON.parse(gbuResultArray[i].jsonContent);
              gbu.gbuClient = gbuResultArray[i].gbuClient;
              gbu.id = gbuResultArray[i].id;
              const gbuReport = gbuResultArray[i].gbuReport;
              if (gbuReport && gbuReport.deleted === false) {
                this.gbuReports.push(gbuReport.id);
              }
              else {
                this.gbuReports.push(null);
              }
              if (gbuResultArray[i].jsonSelectedProtections) {
                this.gbuSelectedProtections.push(JSON.parse(gbuResultArray[i].jsonSelectedProtections))
              }
              else {
                this.gbuSelectedProtections.push(null);
              }
              if (gbu.useGbu) {
                gbu.sumGbuRisks = this.addRiskCounts(gbu.chapters);
              }
              if (gbu.useSurroundingsConsideration) {
                gbu.sumSurroundingsRisks = this.addRiskCounts(gbu.surroundingsChapters);
              }
              if (gbu.useConditionAssessment) {
                const caContent= gbu.conditionAssessment.content === undefined ? []
                    : gbu.conditionAssessment.content;
                if (caContent.length > 0) {
                  for (let subheader of caContent) {
                    subheader.conditionNr = -1;  // no value set, overwriten with 1st item-color-nr
                    for (let item of subheader.content) {
                      if (item.type === 'enum') {
                        // get display-value from number-string-value
                        for (let val of item.items) {
                          if (val.name === item.value) {
                            item.displayValue = val.displayName;
                          }
                        }
                        const nrVal = Number(item.value);
                        if (subheader.conditionNr < nrVal) {
                          // when there are 5 values, value 5 is 'nicht zutreffend'
                          if (!(nrVal === 5 && item.items.length === 5)) {
                            subheader.conditionNr = nrVal;
                          }
                        }
                      }
                    }
                    // special case all items are 'nicht zutreffend'
                    subheader.conditionNr = subheader.conditionNr === -1 ? 5 : subheader.conditionNr;
                  }
                }
              }
              this.gbuResults.push(gbu);
            }
            // console.log(this.gbuResults); // debug info
          }
          this.gbuResultsLoaded= true;
        },
        (error) => {
          this.$logger.info("Error at fetching Gbu-Results: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: 'GBU-Infos'})) // todo: translate
          this.gbuResultsLoaded= true;
        }
    );
    ElevatorStateService.readFromAPI(this.$route.params.id,
        (resp) => {
          let state = DataUtils.parseDataToSingleObject(resp.data, ElevatorState);
          if (state == null) {
            this.$router.push('/404');
            return;
          }

          this.state = state;
          this.translateAndGetElevatorStateFields();

          // get facilityDocumentations which have been uploaded and show them
          // in the according row
          DocumentationService.readPageableFacilityDocumentationsFromAPI(
              this.$route.params.id,
              0,
              -1,
              "",
              "",
              "ALL",
              ["name"],
              [true],
              (res) => {
                this.facilityDocumentations = DataUtils.parseDataToObjectArray(res.data.content, FacilityDocumentation);

                // format savedOn dateTime of documentations
                for (let i = 0; i < this.facilityDocumentations.length; i++) {
                  this.facilityDocumentations[i].formattedSavedOn = DateUtils.parseDateTimeForDisplay(this.facilityDocumentations[i].savedOn);
                }

                EnumService.translateAndSortEnumObject(this.state.ruleStates, "enums:facility-documentation-types.")

                for (let i = 0; i < this.state.ruleStates.length; i++) {
                  this.state.ruleStates[i].documents = [];

                  for (let j = 0; j < this.facilityDocumentations.length; j++) {
                    if (this.state.ruleStates[i].name === this.facilityDocumentations[j].type) {
                      Vue.set(this.state.ruleStates[i].documents, this.state.ruleStates[i].documents.length, this.facilityDocumentations[j])
                    }
                  }
                }

                this.getRuleDocumentations().then(() => {
                  this.$refs.ruleStateTable.facilityState = this.state;
                  this.$refs.ruleStateTable.rulesOrPictures = this.state.ruleStates;

                  InfoService.readAndTranslateEnum(
                      'documentation/facility/image',
                      'enums:facility-documentation-types.',
                      (res) => {
                        this.facilityPictures = res;

                        for (let i = 0; i < this.facilityPictures.length; i++) {
                          this.facilityPictures[i].documents = [];

                          for (let j = 0; j < this.facilityDocumentations.length; j++) {
                            if (this.facilityPictures[i].name === this.facilityDocumentations[j].type) {
                              Vue.set(this.facilityPictures[i].documents, this.facilityPictures[i].documents.length, this.facilityDocumentations[j])
                            }
                          }
                        }

                        for (let picture of this.facilityPictures) {
                          if (picture.documents.length > 0) {
                            for (let document of picture.documents) {
                              DocumentationService.getDocByTypeAndId(
                                  document.id,
                                  document.fileType,
                                  document.documentType,
                                  document.facilityId,
                                  (res) => {
                                    Vue.set(document, "src", res);
                                  },
                                  (error) => {
                                    this.$logger.error("Failed loading documentation source for document " + document.id +", because: " + error);
                                  }
                              )
                            }
                          }
                        }

                        this.$refs.pictureTable.facilityState = this.state;
                        this.$refs.pictureTable.rulesOrPictures = this.facilityPictures;
                      }
                  )
                })

              },
              (error) => {
                this.$logger.info("Error at fetching facility documentations: " + error);
                Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.snackbar.facility-documents')}))
              }
          )
        }
    )
  }
}
</script>

<style scoped>

.full-width {
  width: 100%;
}
.small-text {
  font-size: small;
}
.risk-col {
  text-align: center;
  height: 100%;
}
.center-text {
  text-align: center;
}
.pre-wrap {
  white-space: pre-wrap;
}
.bold {
  font-weight: bold;
}
</style>